<template>
  <app-layout>
    <bax-header-banner :user="this.$store.state.auth.user" :orderStep="1" />

    <main>
      <div class="bax-section bax-select-patient-wrap">
        <div class="container">
          <div class="bax-bg bax-bg-foot-link bax-create-patient">
            <div class="bax-section-title">
              <h1 v-if="!isTPN()">Create a New Order</h1>
              <h1 v-if="isTPN()">Create a New TPN Order</h1>
            </div>
            <div class="">
              <form novalidate @submit.prevent="createOrder">
                <ul class="bax-diamond-list">
                  <li class="bax-diamond-list-item bax-element-active">
                    <div class="bax-form-group" v-bind:class="{ 'bax-form-error' : $v.formData.orderRef.$error }">
                      <label>Create an order reference</label>
                      <input class="bax-input-control" type="text" placeholder="Create an order reference" v-model="formData.orderRef">
                      <p v-if="$v.formData.orderRef.$dirty && !$v.formData.orderRef.required">Required fields</p>
                      <p v-if="$v.formData.orderRef.$dirty && !$v.formData.orderRef.max">Max character allowed is 20</p>
                    </div>
                  </li>
                  <li class="bax-diamond-list-item">
                    <div class="bax-form-group" v-bind:class="{ 'bax-form-error' : $v.formData.deliveryDate.$error }">
                      <label>Required delivery date</label>
                      <date-entry :showDateAlerts="true" v-model="formData.deliveryDate" @update-warning="updateWarning"></date-entry>
                      <p v-if="
                        $v.formData.deliveryDate.$dirty &&
                        !$v.formData.deliveryDate.required
                      ">Required field</p>
                      <p v-if="
                        $v.formData.deliveryDate.$dirty &&
                        !$v.formData.deliveryDate.validDate
                      ">Enter a valid date</p>
                      <p v-if="
                        $v.formData.deliveryDate.$dirty &&
                        !$v.formData.deliveryDate.pastDate
                      ">Please enter a future date</p>
                    </div>


                    <alert-box :title="'Note'" :date_warning="date_warning"></alert-box>

                  </li>
                  <li class="bax-diamond-list-item" v-if="!isTPN()">
                    <div class="bax-form-group">
                      <label>Time required  - <span>Optional</span></label>
                      <select v-model="formData.deliveryTime" class="bax-input-control">
                        <option class="d-none" value="">- Select -</option>
                        <option v-for="(time, index) in timeInHours" :key="index">{{ time }}</option>
                      </select>
                    </div>
                  </li>
                  <li class="bax-diamond-list-item">
                    <div class="bax-form-group" v-bind:class="{ 'bax-form-error' : $v.formData.comment.$dirty && !$v.formData.comment.maxChar }">
                      <label>Notes</label>
                      <textarea rows="10" class="bax-input-control" max="255" v-model="formData.comment"></textarea>
                      <p v-if="$v.formData.comment.$dirty && !$v.formData.comment.maxChar">Maximum character allowed is 255</p>
                    </div>
                  </li>
                </ul>
                <div class="bax-cta-block d-md-flex">
                  <cancel-order-modal></cancel-order-modal>
                  <button
                    type="submit"
                    class="mt-3 mt-md-0 bax-btn bax-btn bax-btn-blue ml-auto"
                  >
                    Continue
                  </button>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </main>
  </app-layout>
</template>

<script>
import moment from 'moment';
import { required } from 'vuelidate/lib/validators';
import { scrollPageToTop } from '@/core/helpers';
import time from '@/constants/time';
import DateEntry from '@/components/ui/DateEntry.vue';
import AppLayout from '@/components/layout/AppLayout.vue';
import OrderService from '@/core/api/order/order.service';
import CancelOrderModal from '@/components/order/CancelOrderModal.vue';
import BaxHeaderBanner from '@/components/layout/BaxHeaderBanner.vue';
import tpnMixin from '@/mixins/tpnMixin';
import AlertBox from '@/components/ui/Alert/AlertBox.vue';

export default {
  name: 'CreateOrder',
  mixins: [tpnMixin],
  components: {
    AppLayout,
    DateEntry,
    AlertBox,
    CancelOrderModal,
    BaxHeaderBanner,
  },
  data() {
    return {
      showCancelDialog: false,
      timeInHours: time.hours,
      date_warning: '',
      formData: {
        orderRef: '',
        deliveryDate: '',
        deliveryTime: '',
        comment: '',
      },
    };
  },
  validations: {
    formData: {
      orderRef: {
        required,
        max(val) {
          if (val === '') {
            return true;
          }

          if (val.length > 20) {
            return false;
          }

          return true;
        },
      },
      deliveryDate: {
        required,
        validDate(val) {
          if (val === '') {
            return true;
          }

          return moment(val, ['DD/MM/YYYY', 'D/M/YYYY'], true).isValid();
        },
        pastDate(val) {
          if (val === '') {
            return true;
          }

          if (moment(val, ['DD/MM/YYYY', 'D/M/YYYY'], true).isValid() === false) {
            return true;
          }

          const today = moment().format('DD/MM/YYYY');

          const now = moment(today, 'DD/MM/YYYY');
          const date = moment(val, 'DD/MM/YYYY');

          if (date.diff(now, 'days') < 0) {
            return false;
          }

          return true;
        },
      },
      comment: {
        maxChar(val) {
          if (val.length > 255) {
            return false;
          }

          return true;
        },
      },
    },
  },
  created() {
    scrollPageToTop();
  },
  methods: {
    updateWarning(newWarning) {
        this.date_warning = newWarning
    },
    updateDeliveryDate(val) {
      this.formData.deliveryDate = val;
    },
    createOrder() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        OrderService.createOrder(this.formData)
          .then((res) => {
              if (!this.isTPN()) {
                  this.$router.push({
                      name: 'selectPatient',
                      params: {
                          orderId: res.data.orderRef,
                      },
                  });
              } else {
                  this.$router.push({
                      name: 'drugDetailTPN',
                      params: {
                          orderId: res.data.orderRef,
                      },
                  });
              }
          });
      }
    },
  },
};
</script>

<style scoped>
.bax-info-icon {
  margin-right: 13px !important;
}
textarea {
  height: 200px;
  font-size: 15px;
}
</style>
